<ul class="sidebar">
  @for (step of model.steps; track step; let index = $index) {
    @if (model.stepViews.get(step).valid) {
      <li class="{{ model.stepViews.get(step).stepCssClass }}" (keyup.enter)="$event.target.click()" (click)="model.navigate(index)" tabindex="0" role="button" [attr.data-cy]="'step-sidenav-' + index">
        <span [ngClass]="isDone(step) ? 'icon icon-check' : ''">{{ !isDone(step) ? displayStepIdx(index) : '' }}</span>
        <div>{{ deCamel(step) }}</div>
      </li>
    }
  }
</ul>
